import React from 'react';
import ReactDOM from 'react-dom';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import 'animate.css';

import { JournalApp } from './JournalApp';

import "./styles/styles.scss"


ReactDOM.render(<JournalApp />, document.getElementById('root'));
